// src/modules/cad/cad-dialog.js


let dialogElement = null;


// ============================================================
// CRS PRESETS
// ============================================================

const CRS_PRESETS = [

    {
        group: "Common",

        items: [

            {
                code: "EPSG:4326",
                name: "WGS 84"
            },

            {
                code: "EPSG:3857",
                name: "WGS 84 / Web Mercator"
            }

        ]
    },


    // --------------------------------------------------------
    // Indonesia - UTM North
    // --------------------------------------------------------

    {
        group: "Indonesia - UTM North",

        items: [

            {
                code: "EPSG:32646",
                name: "WGS 84 / UTM zone 46N"
            },

            {
                code: "EPSG:32647",
                name: "WGS 84 / UTM zone 47N"
            },

            {
                code: "EPSG:32648",
                name: "WGS 84 / UTM zone 48N"
            },

            {
                code: "EPSG:32649",
                name: "WGS 84 / UTM zone 49N"
            },

            {
                code: "EPSG:32650",
                name: "WGS 84 / UTM zone 50N"
            },

            {
                code: "EPSG:32651",
                name: "WGS 84 / UTM zone 51N"
            },

            {
                code: "EPSG:32652",
                name: "WGS 84 / UTM zone 52N"
            },

            {
                code: "EPSG:32653",
                name: "WGS 84 / UTM zone 53N"
            },

            {
                code: "EPSG:32654",
                name: "WGS 84 / UTM zone 54N"
            }

        ]
    },


    // --------------------------------------------------------
    // Indonesia - UTM South
    // --------------------------------------------------------

    {
        group: "Indonesia - UTM South",

        items: [

            {
                code: "EPSG:32746",
                name: "WGS 84 / UTM zone 46S"
            },

            {
                code: "EPSG:32747",
                name: "WGS 84 / UTM zone 47S"
            },

            {
                code: "EPSG:32748",
                name: "WGS 84 / UTM zone 48S"
            },

            {
                code: "EPSG:32749",
                name: "WGS 84 / UTM zone 49S"
            },

            {
                code: "EPSG:32750",
                name: "WGS 84 / UTM zone 50S"
            },

            {
                code: "EPSG:32751",
                name: "WGS 84 / UTM zone 51S"
            },

            {
                code: "EPSG:32752",
                name: "WGS 84 / UTM zone 52S"
            },

            {
                code: "EPSG:32753",
                name: "WGS 84 / UTM zone 53S"
            },

            {
                code: "EPSG:32754",
                name: "WGS 84 / UTM zone 54S"
            }

        ]
    }

];


// ============================================================
// Create Dialog
// ============================================================

function createDialog() {

    if (dialogElement) {

        return dialogElement;

    }


    dialogElement =
        document.createElement("div");

    dialogElement.id =
        "cadLayerDialog";

    dialogElement.className =
        "cad-dialog";


    dialogElement.innerHTML = `

        <div class="cad-dialog-backdrop">

            <div class="cad-dialog-panel">


                <!-- ================================================= -->
                <!-- HEADER -->
                <!-- ================================================= -->

                <div class="cad-dialog-header">

                    <div>

                        <h3>

                            <i class="bi bi-file-earmark-binary"></i>

                            Import CAD

                        </h3>

                        <div
                            class="cad-dialog-file"
                            id="cadDialogFile">
                        </div>

                    </div>


                    <button
                        type="button"
                        class="cad-dialog-close"
                        id="cadDialogClose">

                        &times;

                    </button>

                </div>


                <!-- ================================================= -->
                <!-- BODY -->
                <!-- ================================================= -->

                <div class="cad-dialog-body">


                    <!-- ============================================= -->
                    <!-- DRAWING LAYERS -->
                    <!-- ============================================= -->

                    <div class="cad-section-title">

                        <i class="bi bi-layers"></i>

                        Drawing Layers

                    </div>


                    <div class="cad-dialog-toolbar">

                        <button
                            type="button"
                            id="cadSelectAll"
                            class="cad-dialog-action">

                            <i class="bi bi-check2-square"></i>

                            Semua

                        </button>


                        <button
                            type="button"
                            id="cadSelectNone"
                            class="cad-dialog-action">

                            <i class="bi bi-square"></i>

                            Tidak Ada

                        </button>


                        <span
                            id="cadLayerCount"
                            class="cad-layer-count">
                        </span>

                    </div>


                    <div
                        id="cadLayerList"
                        class="cad-layer-list">
                    </div>


                    <!-- ============================================= -->
                    <!-- CRS -->
                    <!-- ============================================= -->

                    <div class="cad-crs-section">


                        <div class="cad-section-title">

                            <i class="bi bi-globe2"></i>

                            Pilih Sistem Koordinat File DXF

                        </div>


                        <!-- ========================================= -->
                        <!-- CRS SELECT -->
                        <!-- ========================================= -->

                        <div class="cad-crs-dropdown" id="cadCRSDropdown">

                            <!-- Native select tetap dipertahankan -->
                            <select
                                id="cadCRSSelect"
                                class="cad-crs-select">

                                <option value="">
                                    — Pilih Source CRS —
                                </option>

                                ${buildCRSOptions()}

                            </select>

                            <!-- Custom dropdown UI -->
                            <button
                                type="button"
                                id="cadCRSDropdownButton"
                                class="cad-crs-dropdown-button">

                                <span id="cadCRSSelectedText">
                                    — Pilih Source CRS —
                                </span>

                                <span class="cad-crs-dropdown-arrow">
                                    ▾
                                </span>

                            </button>

                            <div
                                id="cadCRSDropdownMenu"
                                class="cad-crs-dropdown-menu">
                            </div>

                        </div>


                        <!-- ========================================= -->
                        <!-- CUSTOM EPSG -->
                        <!-- ========================================= -->

                        <div class="cad-custom-epsg">

                            <label
                                for="cadCustomEPSG">

                                Custom EPSG

                            </label>


                            <div class="cad-epsg-input">

                                <span>
                                    EPSG:
                                </span>

                                <input
                                    id="cadCustomEPSG"
                                    type="number"
                                    min="1"
                                    placeholder="contoh: 32748"
                                />

                            </div>


                            <small>

                                Gunakan jika CRS tidak tersedia
                                pada daftar.

                            </small>

                        </div>


                    </div>

                </div>


                <!-- ================================================= -->
                <!-- FOOTER -->
                <!-- ================================================= -->

                <div class="cad-dialog-footer">


                    <button
                        type="button"
                        id="cadDialogCancel"
                        class="cad-dialog-btn secondary">

                        Batal

                    </button>


                    <button
                        type="button"
                        id="cadDialogImport"
                        class="cad-dialog-btn primary">

                        <i class="bi bi-download"></i>

                        Import Selected

                    </button>


                </div>


            </div>

        </div>

    `;


    document.body.appendChild(dialogElement);


    return dialogElement;

}


// ============================================================
// Show CAD Layer Picker + CRS
// ============================================================

export function showCADLayerPicker({
    fileName,
    layers
}) {

    const dialog =
        createDialog();


    const fileLabel =
        dialog.querySelector(
            "#cadDialogFile"
        );


    const layerList =
        dialog.querySelector(
            "#cadLayerList"
        );


    const layerCount =
        dialog.querySelector(
            "#cadLayerCount"
        );


    const btnSelectAll =
        dialog.querySelector(
            "#cadSelectAll"
        );


    const btnSelectNone =
        dialog.querySelector(
            "#cadSelectNone"
        );


    const btnImport =
        dialog.querySelector(
            "#cadDialogImport"
        );


    const btnCancel =
        dialog.querySelector(
            "#cadDialogCancel"
        );


    const btnClose =
        dialog.querySelector(
            "#cadDialogClose"
        );


    const crsSelect =
        dialog.querySelector(
            "#cadCRSSelect"
        );

    initCADCRSDropdown(dialog);

    const customEPSG =
        dialog.querySelector(
            "#cadCustomEPSG"
        );


    fileLabel.textContent =
        fileName;


    // ========================================================
    // Layer List
    // ========================================================

    if (
        !layers ||
        layers.length === 0
    ) {

        layerList.innerHTML = `

            <div class="cad-empty">

                Tidak ada drawing layer
                yang ditemukan.

            </div>

        `;

        layerCount.textContent =
            "";

    }

    else {

        layerList.innerHTML =

            layers
                .map(
                    (layer, index) => {

                        const name =
                            layer.layer_name ??
                            layer.name ??
                            `Layer ${index + 1}`;


                        const safeId =
                            `cad-layer-${index}`;


                        return `

                            <label
                                class="cad-layer-item"
                                for="${safeId}"
                            >

                                <input
                                    type="checkbox"
                                    id="${safeId}"
                                    class="cad-layer-checkbox"
                                    data-index="${index}"
                                    checked
                                >


                                <span
                                    class="cad-layer-name">

                                    ${escapeHTML(name)}

                                </span>

                            </label>

                        `;

                    }
                )
                .join("");


        updateLayerCount(
            layerList,
            layerCount
        );

    }


    // ========================================================
    // Select All
    // ========================================================

    btnSelectAll.onclick = () => {

        layerList
            .querySelectorAll(
                ".cad-layer-checkbox"
            )
            .forEach(
                input => {

                    input.checked =
                        true;

                }
            );


        updateLayerCount(
            layerList,
            layerCount
        );

    };


    // ========================================================
    // Select None
    // ========================================================

    btnSelectNone.onclick = () => {

        layerList
            .querySelectorAll(
                ".cad-layer-checkbox"
            )
            .forEach(
                input => {

                    input.checked =
                        false;

                }
            );


        updateLayerCount(
            layerList,
            layerCount
        );

    };


    // ========================================================
    // Checkbox Change
    // ========================================================

    layerList.onchange = () => {

        updateLayerCount(
            layerList,
            layerCount
        );

    };


    // ========================================================
    // CRS change
    // ========================================================

    crsSelect.onchange = () => {

        if (crsSelect.value) {

            customEPSG.value =
                "";

        }

    };


    // ========================================================
    // Custom EPSG
    // ========================================================

    customEPSG.oninput = () => {

        if (customEPSG.value.trim()) {

            crsSelect.value =
                "";

        }

    };


    // ========================================================
    // Promise
    // ========================================================

    return new Promise(
        resolve => {

            let finished =
                false;


            const finish =
                result => {

                    if (finished) {

                        return;

                    }


                    finished =
                        true;


                    dialog.classList.remove(
                        "show"
                    );


                    resolve(result);

                };


            // ====================================================
            // Cancel
            // ====================================================

            btnCancel.onclick =
                () => {

                    finish(null);

                };


            btnClose.onclick =
                () => {

                    finish(null);

                };


            // ====================================================
            // Click Backdrop
            // ====================================================

            const backdrop =
                dialog.querySelector(
                    ".cad-dialog-backdrop"
                );


            backdrop.onclick =
                event => {

                    if (
                        event.target !==
                        backdrop
                    ) {

                        return;

                    }


                    finish(null);

                };


            // ====================================================
            // IMPORT
            // ====================================================

            btnImport.onclick =
                () => {


                    // --------------------------------------------
                    // Selected layers
                    // --------------------------------------------

                    const selected =

                        [
                            ...layerList
                                .querySelectorAll(
                                    ".cad-layer-checkbox:checked"
                                )
                        ]

                        .map(
                            input => {

                                const index =
                                    Number(
                                        input.dataset.index
                                    );

                                return layers[index];

                            }
                        );


                    if (
                        selected.length === 0
                    ) {

                        alert(
                            "Pilih minimal satu layer CAD."
                        );

                        return;

                    }


                    // --------------------------------------------
                    // CRS
                    // --------------------------------------------

                    let sourceCRS =
                        crsSelect.value;


                    // Custom EPSG
                    if (
                        customEPSG.value.trim()
                    ) {

                        const code =
                            Number(
                                customEPSG.value.trim()
                            );


                        if (
                            !Number.isInteger(code) ||
                            code <= 0
                        ) {

                            alert(
                                "EPSG code tidak valid."
                            );

                            return;

                        }


                        sourceCRS =
                            `EPSG:${code}`;

                    }


                    // --------------------------------------------
                    // CRS wajib
                    // --------------------------------------------

                    if (!sourceCRS) {

                        alert(
                            "Pilih Source CRS/Sistem Koordinataa terlebih dahulu."
                        );

                        return;

                    }


                    console.log(
                        "[CAD] Selected CRS:",
                        sourceCRS
                    );


                    // --------------------------------------------
                    // Return
                    // --------------------------------------------

                    finish({

                        layers:
                            selected,

                        sourceCRS

                    });

                };


            // ====================================================
            // Show
            // ====================================================

            dialog.classList.add(
                "show"
            );

        }
    );

}


// ============================================================
// Build CRS options
// ============================================================

function buildCRSOptions() {

    return CRS_PRESETS

        .map(
            group => {

                return `

                    <optgroup
                        label="${escapeHTML(group.group)}">

                        ${
                            group.items
                                .map(
                                    item => `

                                        <option
                                            value="${item.name}">
                                            

                    
                                            ${escapeHTML(item.name)}

                                        </option>

                                    `
                                )
                                .join("")
                        }

                    </optgroup>

                `;

            }
        )

        .join("");

}


function initCADCRSDropdown(dialog) {

    const crsSelect =
        dialog.querySelector("#cadCRSSelect");

    const dropdown =
        dialog.querySelector("#cadCRSDropdown");

    const button =
        dialog.querySelector("#cadCRSDropdownButton");

    const menu =
        dialog.querySelector("#cadCRSDropdownMenu");

    const selectedText =
        dialog.querySelector("#cadCRSSelectedText");

   
    if (
        !crsSelect ||
        !dropdown ||
        !button ||
        !menu ||
        !selectedText
    ) {

        console.warn(
            "[CAD] CRS dropdown element tidak lengkap."
        );

        return;
    }


    // ========================================================
    // BUILD MENU DARI OPTION YANG SUDAH ADA
    // ========================================================

    menu.innerHTML = "";


    const options =
        Array.from(
            crsSelect.options
        );

        console.log("[CAD CRS] jumlah options:", options.length);
        console.log(
            "[CAD CRS] options:",
            options.map(o => ({
                value: o.value,
                text: o.textContent
            }))
        );


    options.forEach(
        option => {

            // ----------------------------------------------
            // Skip option kosong
            // ----------------------------------------------

            if (
                !option.value
            ) {
                return;
            }


            const item =
                document.createElement(
                    "div"
                );


            item.className =
                "cad-crs-option";


            item.dataset.value =
                option.value;


            item.textContent =
                option.textContent
                    .trim();


            // ----------------------------------------------
            // Click
            // ----------------------------------------------

            item.addEventListener(
                "click",
                event => {

                    event.preventDefault();

                    event.stopPropagation();


                    // Set native select
                    crsSelect.value =
                        option.value;


                    // Trigger existing logic
                    crsSelect.dispatchEvent(
                        new Event(
                            "change",
                            {
                                bubbles: true
                            }
                        )
                    );


                    // Update text
                    selectedText.textContent =
                        option.textContent
                            .trim();


                    // Update selected
                    menu
                        .querySelectorAll(
                            ".cad-crs-option"
                        )
                        .forEach(
                            el => {

                                el.classList.toggle(
                                    "selected",
                                    el.dataset.value ===
                                    crsSelect.value
                                );

                            }
                        );


                    // Close
                    dropdown.classList.remove(
                        "open"
                    );

                }
            );


            menu.appendChild(
                item
            );

        }
    );

    console.log(
    "[CAD CRS] custom menu children:",
    menu ? menu.children.length : "MENU NULL"
    );

    console.log("[CAD CRS] menu display:", menu ? getComputedStyle(menu).display : "NULL");
    console.log("[CAD CRS] menu visibility:", menu ? getComputedStyle(menu).visibility : "NULL");
    console.log("[CAD CRS] menu rect:", menu ? menu.getBoundingClientRect() : "NULL");

    // ========================================================
    // BUTTON
    // ========================================================

    button.onclick = event => {
        event.preventDefault();
        event.stopImmediatePropagation();

        dropdown.classList.toggle("open");
    };

    // ========================================================
    // CLICK OUTSIDE
    // ========================================================

    document.addEventListener("pointerdown", event => {
        if (!dropdown.contains(event.target)) {
            dropdown.classList.remove("open");
        }
    });

    // ========================================================
    // SYNC JIKA SELECT BERUBAH
    // ========================================================

    crsSelect.addEventListener(
        "change",
        () => {

            const selected =
                crsSelect.options[
                    crsSelect.selectedIndex
                ];


            if (
                !selected ||
                !selected.value
            ) {

                selectedText.textContent =
                    "— Pilih Source CRS —";

            }

            else {

                selectedText.textContent =
                    selected.textContent
                        .trim();

            }


            menu
                .querySelectorAll(
                    ".cad-crs-option"
                )
                .forEach(
                    item => {

                        item.classList.toggle(
                            "selected",
                            item.dataset.value ===
                            crsSelect.value
                        );

                    }
                );

        }
    );


    // ========================================================
    // INITIAL STATE
    // ========================================================

    selectedText.textContent =
        "— Pilih Source CRS —";

}

// ============================================================
// Update Layer Count
// ============================================================

function updateLayerCount(
    layerList,
    layerCount
) {

    const total =
        layerList.querySelectorAll(
            ".cad-layer-checkbox"
        ).length;


    const selected =
        layerList.querySelectorAll(
            ".cad-layer-checkbox:checked"
        ).length;


    layerCount.textContent =
        `${selected} / ${total} dipilih`;

}


// ============================================================
// Escape HTML
// ============================================================

function escapeHTML(value) {

    return String(value)

        .replace(
            /&/g,
            "&amp;"
        )

        .replace(
            /</g,
            "&lt;"
        )

        .replace(
            />/g,
            "&gt;"
        )

        .replace(
            /"/g,
            "&quot;"
        )

        .replace(
            /'/g,
            "&#039;"
        );

}